// extracted by css-extract-rspack-plugin
export default {"root":"root-v2J4Zd","title":"title-bFnk7U text-headline-sm","decoration":"decoration-rhyjyi","main":"main-zzl0QU","content":"content-u9icMx text-body-base"};